import $apiJSON from 'http/apiJSON'

const BASE = '/gradebook'

export async function listStatements(params = {}) {
  return $apiJSON.get(`${BASE}/statements/`, { params })
}

export async function getStatement(id) {
  return $apiJSON.get(`${BASE}/statements/${id}/`)
}

export async function createStatement(payload) {
  return $apiJSON.post(`${BASE}/statements/`, payload)
}

export async function updateStatement(id, payload) {
  return $apiJSON.patch(`${BASE}/statements/${id}/`, payload)
}

export async function deleteStatement(id) {
  return $apiJSON.delete(`${BASE}/statements/${id}/`)
}

export async function signStatement(id, payload = {}) {
  return $apiJSON.post(`${BASE}/statements/${id}/sign/`, payload)
}

export async function closeStatement(id, payload = {}) {
  return $apiJSON.post(`${BASE}/statements/${id}/close/`, payload)
}

export function statementPdfUrl(id) {
  return `${BASE}/statements/${id}/pdf/`
}

export async function downloadStatementPDF(id) {
  const response = await $apiJSON.get(`${BASE}/statements/${id}/pdf/`, {
    responseType: 'blob',
  })
  const blob = new Blob([response.data], { type: 'application/pdf' })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = `statement-${id}.pdf`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
  return response
}

export async function listGradebook(params = {}) {
  return $apiJSON.get(`${BASE}/gradebook/`, { params })
}

export async function getGradebookEntry(id) {
  return $apiJSON.get(`${BASE}/gradebook/${id}/`)
}

export async function listRetakes(params = {}) {
  return $apiJSON.get(`${BASE}/retakes/`, { params })
}

export async function createRetake(payload) {
  return $apiJSON.post(`${BASE}/retakes/`, payload)
}

export async function updateRetake(id, payload) {
  return $apiJSON.patch(`${BASE}/retakes/${id}/`, payload)
}

export async function deleteRetake(id) {
  return $apiJSON.delete(`${BASE}/retakes/${id}/`)
}

export default {
  listStatements,
  getStatement,
  createStatement,
  updateStatement,
  deleteStatement,
  signStatement,
  closeStatement,
  statementPdfUrl,
  downloadStatementPDF,
  listGradebook,
  getGradebookEntry,
  listRetakes,
  createRetake,
  updateRetake,
  deleteRetake,
}
